import { Component, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { FeatureResponseModel } from "src/app/model/FeatureResponseModel";
import { Page } from "src/app/model/Page";
import { MasterService } from "src/app/services/master.service";

@Component({
  selector: 'app-secure-feature-list',
  templateUrl: './feature-list.component.html',
  styleUrls: ['./feature-list.component.scss'],
})
export class FeatureListComponent implements  OnInit  {
  loaded: boolean = false;
  page: Page<FeatureResponseModel>;
  dataSource: MatTableDataSource<FeatureResponseModel> = new MatTableDataSource();
  pageSizeOptions: number[] = [10, 25, 100];
  isLoading = false;
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  filterForm: FormGroup = new FormGroup({});
  isSearchDisabled: boolean = false;

  displayedColumns: string[] = [
    "id",
    "featureIcon",
    "featureLabel",
    "backEndCode",
    "displayOrder",
    "action"
  ];
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(public dialog: MatDialog,
    private masterService: MasterService,
    private router: Router,
    private _snackBar: MatSnackBar
    ) {}

  ngOnInit(): void { 
    this.filterForm = new FormGroup({
      filterText: new FormControl(null, [Validators.required, Validators.minLength(3)])
    });

    this.loadData(); 
  }

  resetFilter() {
    this.filterForm.controls['filterText'].setValue(null);
    this.loadData();
  }

  onSearch() {
    if (this.filterForm.valid) {
      this.isLoading = true;
      this.loadData();
    }
    else {
      this._snackBar.open("Please enter Filter text (minimum - 3 char) for Feature", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "warning-toast",
        duration: 3 * 1000,
      });
      this.isSearchDisabled = false;
    }
  }

  loadData() {
    this.masterService.getFeatureList(this.currentPage, this.pageSize, this.filterForm.value.filterText).subscribe((page: any)=>{
      this.isLoading = false;
      this.loaded = true;
      this.page = page;
      this.dataSource = new MatTableDataSource(page.content);
      setTimeout(() => {
        this.paginator.pageIndex = this.currentPage;
        this.paginator.length = page.totalElements;
      });
      this.isSearchDisabled = false;
    },
    (error) => {
        console.log(error);
        this.isLoading = false;
        this.isSearchDisabled = false;
    });
  }
  
  pageChanged(event: PageEvent) {
    console.log({ event });
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.loadData();
  }

  edit(organizationKey: number) {
    this.router.navigate(['/secure', 'master', 'feature', 'au', organizationKey]);
  }

  deactivate(key: number) {
   if(confirm("Do you want to De-Activate the Feature")) {
    this.masterService.toggleActivationFeature(key, 'N').subscribe((data: any)=>{
      if(data.status === 'SUCCESS') {
        let selectedObj = this.page.content.find(o => o.key === key);
        selectedObj.activeFlag = 'N';
      }
      else {
        this.errorToast(data.errorMessage);
      }
    });
   } 
  }

  activate(key: number) {
    if(confirm("Do you want to Activate the Feature")) {
      this.masterService.toggleActivationFeature(key, 'Y').subscribe((data: any)=>{
        if(data.status === 'SUCCESS') {
          let selectedObj = this.page.content.find(o => o.key === key);
          selectedObj.activeFlag = 'Y';
        }
        else {
          this.errorToast(data.errorMessage);
        }
      });
    } 
  }

  async errorToast(errorMessage: string) {
    await this._snackBar.open(errorMessage, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: 3 * 1000,
    });
  }
}
